import React, { Component } from "react";
import { CheckCircle } from "lucide-react";

class AccountCreated extends Component {
  render() {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm z-50">
        <div className="flex flex-col items-center gap-4 bg-white rounded-2xl shadow-xl px-10 py-10 w-full max-w-sm mx-4 text-center">
          <div className="w-16 h-16 rounded-full bg-emerald-50 flex items-center justify-center">
            <CheckCircle className="w-8 h-8 text-emerald-500" />
          </div>
          <div>
            <p className="font-SFPro font-bold text-gray-900 text-lg mb-1">
              Account created!
            </p>
            <p className="font-inter text-sm text-gray-500">
              You have successfully created your CX2 AI account. Redirecting you to sign in…
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default AccountCreated;
